import * as CustomizationModule from 'config/customization';
import activatedModules from 'modules';

activatedModules.push(CustomizationModule.moduleInstance);
const activeModules = activatedModules;

export default activeModules;
